import {useEffect, useRef, useState} from 'react';
import {portalApiGet} from '@/lib/portal-api';
import {AcButton, DataTable} from '@/dashboard/ui';
import type {WorkstationRecentWalkin} from '@/dashboard/types';
import WalkinSourceCorrectionDoor, {baselineFromWalkin, sourceLabel} from '@/walkin/WalkinSourceCorrectionDoor';
import {appointmentDateTime} from '@/dashboard/appointments/AppointmentHistory';

interface ArrivalPage {patientId:string;page:number;total:number;hasMore:boolean;rows:WorkstationRecentWalkin[]}
export default function PatientArrivalHistory({patientId}:{patientId:string}): JSX.Element {
  const [page,setPage]=useState(0),[version,setVersion]=useState(0);
  const [result,setResult]=useState<ArrivalPage|null>(null),[error,setError]=useState<string|null>(null);
  const generation=useRef(0);
  const read=(p=page)=>portalApiGet<ArrivalPage>(`/patient-master/patients/${patientId}/arrivals?page=${p}`);
  useEffect(()=>{const id=++generation.current;setResult(null);setError(null);
    read().then(data=>{if(id===generation.current)setResult(data)}).catch(e=>{if(id===generation.current)setError(e instanceof Error?e.message:'Arrival history unavailable.')});
    return()=>{generation.current++};
  },[patientId,page,version]);
  const visible=result?.patientId===patientId&&result.page===page?result:null;
  return <section aria-label="Arrival history" data-testid="patient-arrival-history">
    <h2>Arrival history</h2>
    {error?<><p role="alert">{error}</p><AcButton onClick={()=>setVersion(v=>v+1)}>Retry</AcButton></>:!visible?<p role="status">Loading arrivals…</p>:<>
      {!visible.rows.length?<p>No arrivals recorded.</p>:<DataTable label="Arrival history" rows={visible.rows} rowKey={r=>String(r.id)} columns={[
        {key:'date',header:'Arrived',render:r=>appointmentDateTime(r.walkedInAt)},
        {key:'source',header:'Source',render:r=>r.source ? sourceLabel(r.source) : 'Not recorded'},
        {key:'detail',header:'Details',render:r=>r.sourceDetail||'—'},
        {key:'action',header:'',render:r=><WalkinSourceCorrectionDoor key={`${r.id}:${r.source}:${r.sourceDetail}`} walkin={r}
          onCorrected={()=>setVersion(v=>v+1)} reloadWalkin={async id=>{const fresh=await read();const row=fresh.rows.find(x=>String(x.id)===String(id));return row?baselineFromWalkin(row):null}}/>},
      ]}/>}
      <p>{visible.total} recorded {visible.total===1?'arrival':'arrivals'}</p>
      {page>0||visible.hasMore?<div className="ac-action-row"><AcButton disabled={page===0} onClick={()=>setPage(p=>p-1)}>Previous</AcButton><AcButton disabled={!visible.hasMore} onClick={()=>setPage(p=>p+1)}>Next</AcButton></div>:null}
    </>}
  </section>;
}
